import { Helmet } from 'react-helmet-async';

import { JobCreateView } from 'src/sections/job/view';

// ----------------------------------------------------------------------

export default function JobCreatePage() {
  return (
    <>
      <Helmet>
        <title> Create shipment</title>
      </Helmet>

      <JobCreateView />
    </>
  );
}
